import React, { Component } from 'react';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import VerifyOTP from '../Auth/VerifyOTP';
import { has, map, isEmpty } from 'lodash';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import { defaultImageOnError } from '../../helpers';

export default class ContactDetails extends Component {
  constructor(props) {
    super(props);

    this.errors = {
      name: false,
      email: false,
      phone: false,
      companyName: false,
      address1: false,
      address2: false,
      address3: false,
      refNo: false
      // 'terms': false
    };
    this.initialFormData = {
      name: '',
      email: '',
      phone: '',
      companyName: false,
      address1: false,
      address2: false,
      address3: false,
      refNo: false,
      terms: true,
      mobileChk: ''
    };
    this.state = {
      uploadImageFile: `${imageBasePath}/pic.png`,
      propsAvoid: false
    };
    this.formData = {
      ...this.initialFormData
    };
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.sendOTPAction = this.sendOTPAction.bind(this);
    this.imageUpload = this.imageUpload.bind(this);
    this.noImageColor = this.noImageColor.bind(this);
    this.setImageURL = this.setImageURL.bind(this);
  }

  componentWillMount() {
    this.props.actions.getVendorInfo();
    this.noImageColor();
  }

  componentWillReceiveProps(nextprops) {
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    let userInfo = nextprops.userReducer.vendorInfo;

    //alert(JSON.stringify(nextprops.userReducer.toastMessage));
    if (userInfo && !this.state.propsAvoid) {
      this.initialFormData.mobileChk = authData.phone.length == 13 ? authData.phone.substring(4, 13) : authData.phone;
      this.setState({
        imagesrc: authData.profilePhoto ? this.props.authData.profilePhoto : `${imageBasePath}/pic.png`,
        username: authData.name,
        Aemail: authData.email,
        userphoneNo: this.initialFormData.mobileChk,
        userCompanyName: userInfo.companyname,
        addressOne: userInfo.addressline1,
        addressTwo: userInfo.addressline2,
        addressThree: userInfo.addressline3,
        registerNo: userInfo.companyregistrationnumber,
        uploadImageFile: isEmpty(authData.profilePhoto) ? `${imageBasePath}/pic.png` : authData.profilePhoto,
        submitedData: '',
        businessData: ''
      });
    }
  }

  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }

  onFieldChange(value, name, validateError) {
    this.setState({ formError: false });
    this.formData[name] = value;
    this.errors[name] = value ? false : true;

    if (name === 'name' && this.errors[name] === false) {
      this.setState({ username: value });
    } else if (name === 'phone') {
      /*else if(name === 'email' && this.errors[name] === false) {
      this.state.Aemail = value;
      this.setState({Aemail :value});
    }*/
      this.setState({ userphoneNo: value });
    } else if (name === 'companyName' && this.errors[name] === false) {
      this.setState({ userCompanyName: value });
    } else if (name === 'address1' && this.errors[name] === false) {
      this.setState({ addressOne: value });
    } else if (name === 'address2' && this.errors[name] === false) {
      this.setState({ addressTwo: value });
    } else if (name === 'address3' && this.errors[name] === false) {
      this.setState({ addressThree: value });
    } else if (name === 'refNo' && this.errors[name] === false) {
      this.setState({ registerNo: value });
    }
  }
  onSubmit() {
    var data = null;
    this.state.businessData = this.props.userReducer.vendorInfo;
    this.state.submitedData = {
      name: this.state.username,
      // 'email': this.state.Aemail,
      phone: '+971' + this.state.userphoneNo,
      otp: '',
      profile_photo: this.state.uploadImageFile
    };
    this.state.businessData = {
      id: this.props.userReducer.vendorInfo.id,
      userId: this.props.userReducer.vendorInfo.userId,
      companyname: this.state.userCompanyName,
      addressline1: this.state.addressOne,
      addressline2: this.state.addressTwo,
      addressline3: this.state.addressThree,
      companyregistrationnumber: this.state.registerNo,
      tradecopy: this.props.userReducer.vendorInfo.tradecopy,
      logo: this.props.userReducer.vendorInfo.logo,
      user: this.props.userReducer.vendorInfo.user
    };
    let checkValue = document.getElementsByClassName('form-group');
    map(checkValue, function(value, key) {
      data += value.className;
    });
    let checkError = data.indexOf('error') !== -1 ? true : false;
    if (checkError) {
      this.props.actions.showErrorMessage('please correct the errors on this form');
    }
    else if (this.initialFormData.mobileChk != this.state.userphoneNo) {
      //this.sendOTPAction();
      localStorage.setItem('verifyotp', JSON.stringify(this.state.submitedData));
      localStorage.setItem('BusinessData', JSON.stringify(this.state.businessData));
      this.props.router.push(`${appBasePath}/verify-otp/verify`);
    }
    else {
      this.props.actions.contactDetailsUpdate(this.state.submitedData, this.state.businessData);
      this.state.propsAvoid = false;
    }
  }

  sendOTPAction(e) {
    //e.preventDefault();
    const { router } = this.props;
    let formData = {
      ...this.formData
    };
    /*let validForm = true;
    for (const key in formData) {
      if (!formData[key]) {
        this.errors[key] = true;
        validForm = false;
      } else
        this.errors[key] = false;
    }
    if (!validForm) {
      this.setState({ submissionError: true });
      return;
    } else {*/
    this.setState({ submissionError: false });
    let phone_no = this.formData.phone;
    if (!phone_no.startsWith('+')) {
      phone_no = '+' + phone_no;
    }
    //if (this.formData.password.length >= 6) {
    this.props.actions.showVerifyOTPPage({
      name: this.state.username,
      email: this.props.authData.email,
      phone: phone_no,
      password: 'test123',
      type: 'customer',
      usertype: 'customer'
    });
    //}
    //}
  }
  imageUpload(e) {
    let file = e.target.files[0];
    let errMesg = 'Sorry, your image exceeds the file size limit of 1mb, Try again with another image.';
    let propsFunc = this.props.actions;
    let resp = '';
    let that = this;
    let uploadedImgObj = {};
    if (file.size >= 25000000) {
      this.props.actions.showErrorMessage(errMesg);
    } else {
      this.props.actions.sign_request(file, 'dp', function(resp) {

        //that.setState({uploadImageFile: resp.data.url});
        propsFunc.uploadImageDP(file, resp.data.signed_request, resp.data.url, function() {
          that.setImageURL(resp.data.url);
        });
      });
    }
  }

  setImageURL(url) {
    console.log("img url = ", url);
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    authData.profilePhoto = url;
    localStorage.setItem('businessAuthData', JSON.stringify(authData));
    this.setState({ uploadImageFile: url });
  }

  noImageColor() {
    const nameFirstLetter = this.props.authData.name.toUpperCase();
    let colorChange = '';
    if (nameFirstLetter.charCodeAt(0) > 64 && nameFirstLetter.charCodeAt(0) <= 69) {
      colorChange = { color: '#EAABAA' };
    } else if (nameFirstLetter.charCodeAt(0) > 69 && nameFirstLetter.charCodeAt(0) <= 74) {
      colorChange = { color: '#AED5D1' };
    } else if (nameFirstLetter.charCodeAt(0) > 74 && nameFirstLetter.charCodeAt(0) <= 79) {
      colorChange = { color: '#D0E2B2' };
    } else if (nameFirstLetter.charCodeAt(0) > 79 && nameFirstLetter.charCodeAt(0) <= 84) {
      colorChange = { color: '#F7E196' };
    } else if (nameFirstLetter.charCodeAt(0) > 84 && nameFirstLetter.charCodeAt(0) <= 90) {
      colorChange = { color: '#DBDBD9' };
    } else {
      colorChange = { color: '#C7C7E5' };
    }

    this.setState({
      profilePikColor: colorChange,
      firstCharacter: nameFirstLetter.charAt(0)
    });
  }

  render() {
    const { authReducer, userReducer, commonReducer } = this.props;

    return (
      <div>
        <div className="container">
          <div className="row clearfix">
            <div className="col-sm-3">
              <div className="image-element image-element-mob">
                {this.state.uploadImageFile &&
                  !commonReducer.profileImageUploaded &&
                  <img src={this.state.uploadImageFile} className="imageupl imageupl-mob"
                  onError={(e)=>{e.target.onerror = null; e.target.src= defaultImageOnError()}}/>}
                {commonReducer.profileImageUploaded &&
                  <div className="c-loader-img">
                    <img
                      className="img-loader-on-upload imageupl loader-back"
                      src={`${imageBasePath}/loader_white.gif`}
                      alt="Upload in progress"
                    />
                  </div>}
                {/*!this.state.uploadImageFile && !userReducer.profileImageUploaded
                   <p className="imageupl noImage" style={this.state.profilePikColor}>{this.state.firstCharacter}</p>
                   */}
                <label htmlFor="file-upload" className="custom-file-upload custom-file-upload-mob">
                  <i className="glyphicon glyphicon-camera" />
                </label>
                <input id="file-upload" type="file" accept="image/*" onChange={e => this.imageUpload(e)} />
              </div>
            </div>
            <div className="col-sm-9">
              <div className="form-info form-info-mob contact-details-disable">
                <div className="contact-sub-header">CONTACT DETAILS</div>
                <TextInput
                  type="text"
                  label="Name"
                  name="name"
                  value={this.state.username}
                  validationError={'Enter your name'}
                  showValidationError={this.errors['name']}
                  validationError="Enter your name"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="email"
                  label="Email"
                  name="email"
                  customClass="disable-text"
                  value={this.state.Aemail}
                  validationError="Please enter your email id"
                  showValidationError={this.errors['email']}
                  onChange={this.onFieldChange.bind(this)}
                  disabled
                />
                <TextInput
                  type="phone"
                  label="Mobile Number"
                  name="phone"
                  value={this.state.userphoneNo}
                  showValidationError={this.errors['phone']}
                  validationError="Enter a valid mobile number"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="text"
                  label="Company Name"
                  name="companyName"
                  value={this.state.userCompanyName}
                  showValidationError={this.errors['companyName']}
                  validationError="Enter a valid Company Name"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="text"
                  label="Address Line 1"
                  name="address1"
                  value={this.state.addressOne}
                  showValidationError={this.errors['address1']}
                  validationError="Enter a valid Address"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="text"
                  label="Address Line 2"
                  name="address2"
                  value={this.state.addressTwo}
                  showValidationError={this.errors['address2']}
                  validationError="Enter a valid Address"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="text"
                  label="Address Line 3"
                  name="address3"
                  value={this.state.addressThree}
                  showValidationError={this.errors['address3']}
                  validationError="Enter a valid Address"
                  onBlur={this.onFieldChange.bind(this)}
                />
                <TextInput
                  type="text"
                  label="Company Registration Number"
                  name="refNo"
                  value={this.state.registerNo}
                  showValidationError={this.errors['refNo']}
                  validationError="Enter a valid Address"
                  onBlur={this.onFieldChange.bind(this)}
                />



              </div>

            </div>
            <div className="form-group bottom-controls visible-xs">
              <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                <div className="row visible-xs">
                  <div className="col-xs-6 add-veh-mob">
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Save"
                      btnCallBack={() => this.onSubmit(this)}
                      customClass="btn-theme-save add-vehcile-save-btn"
                    />
                  </div>
                  <div className="col-xs-6 add-veh-mob  hidden-xs">
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Cancel"
                      btnCallBack={() => window.history.back()}
                      customClass="btn-theme add-vehcile-cancel-btn"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
          <Button
            btnType="label"
            btnSize="sm"
            fontSize={16}
            label="Save"
            btnCallBack={() => this.onSubmit(this)}
            customClass="btn-theme-save hidden-xs"
          />


        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAccounts/ContactDetails.jsx